import { APICallV3Post } from 'reactApp/api/APICall';

export class FavoritesDeleteAPICall extends APICallV3Post {
    _method = 'favorites/remove';
}
